import React from 'react'
import flatMap from 'lodash/flatMap'

import { FNA } from '@containers/FNA'
import { ParticipantFilter } from './ParticipantFilter'

export const JointFna = ({ participantsQueries, config }) => {
  const [selectedParticipantId, setSelectedParticipantId] = React.useState(participantsQueries[0].participant.id)
  const selectedParticipantQuery = participantsQueries.find((participantQuery) => participantQuery.participant.id === selectedParticipantId)

  const fna = selectedParticipantQuery
    ? selectedParticipantQuery.fna.data
    : flatMap(participantsQueries, (participantQuery) => participantQuery.fna.data)

  return (
    <>
      <FNA
        filter={() => (
          <div>
            <ParticipantFilter
              filteredItemsName={'FNA'}
              participantsQueries={participantsQueries}
              selectedParticipantId={selectedParticipantId}
              setSelectedParticipantId={setSelectedParticipantId}
            />
          </div>
        )}
        fna={fna}
        crudActions={selectedParticipantQuery?.fna.actions}
        assets={selectedParticipantQuery?.assets.data}
        liabilities={selectedParticipantQuery?.liabilities.data}
        riskProducts={selectedParticipantQuery?.riskProducts.data}
        budget={selectedParticipantQuery?.budget.data}
        supportedCurrencies={config.supportedCurrencies}
      />
    </>
  )
}
